module.exports = __webpack_public_path__ + "static/img/nav4.8c29360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav4.jpg
// module id = L8ik
// module chunks = 62